import React, { useState } from 'react';
import { BREAKPOINTS, Container, Flex } from '@/ui';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router';
import { AppSideBar } from '@/components';
import { COLORS } from '@/utils/static';
import { Header } from '@/layouts/components';

export const InvestorLayout = ({ referralView = false }) => {
  const { userRole } = useSelector((state) => state.user);
  const [menuVisible, setMenuVisible] = useState(false);

  const openMenu = () => {
    setMenuVisible(true);
  };

  const closeMenu = () => {
    setMenuVisible(false);
  };

  if (userRole) {
    return (
      <StyledRow $wide $nowrap $relative>
        <AppSideBar
          userRole={userRole}
          menuVisible={menuVisible}
          openMenu={openMenu}
          closeMenu={closeMenu}
          referralView={referralView}
        />

        <Header routerMode='investor' setMenuVisible={setMenuVisible} />

        <StyledMainBlock $wide>
          <Outlet />
        </StyledMainBlock>
      </StyledRow>
    );
  }

  return null;
};

const StyledRow = styled(Flex)`
  background-color: ${COLORS.white};
`;

const StyledMainBlock = styled(Container)`
  min-height: 100vh;
  padding: 56px 24px 16px 308px;

  @media (max-width: ${BREAKPOINTS.md}px) {
    padding: 52px 18px 16px;
  }
`;
